import { render, staticRenderFns } from "./sub_subjects.vue?vue&type=template&id=2b437114&scoped=true&"
import script from "./sub_subjects.vue?vue&type=script&lang=js&"
export * from "./sub_subjects.vue?vue&type=script&lang=js&"
import style0 from "./sub_subjects.vue?vue&type=style&index=0&id=2b437114&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b437114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b437114')) {
      api.createRecord('2b437114', component.options)
    } else {
      api.reload('2b437114', component.options)
    }
    module.hot.accept("./sub_subjects.vue?vue&type=template&id=2b437114&scoped=true&", function () {
      api.rerender('2b437114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/budget_subjects/form/sub_subjects.vue"
export default component.exports